//@vendor
const get = require('lodash/object/get');
//@constants
const actionTypes = require('constants/actionTypes');
const { CARD_MODIFY_LIMIT_INCREASE_APPROVED, CARD_MODIFY_LIMIT_INCREASE_PENDING, CARD_MODIFY_LIMIT_DECREASE, FIRST_STEP, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE } = require('constants/index');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
//@actions
const { requestDecreaseLimit } = require('actions/cardDecreaseLimit');
const { requestIncreaseLimit } = require('actions/cardIncreaseLimit');
//@utilities
const { APIGet } = require('utilities/APIRequestHelper');

const getSuggestedAmount = immModifyLimit => {
    const immStepOne = immModifyLimit.getIn(['steps', FIRST_STEP]);
    const maximumLimitAutorize = immStepOne.get('maximumLimitAutorize');
    const currentLimit = immStepOne.get('currentLimit');
    const limitsList = immModifyLimit.getIn(['increaseLimits', 'limitsList']);

    return limitsList
        .filter(limit => limit <= maximumLimitAutorize && limit !== currentLimit)
        .max();
};

const shouldShowModal = immModifyLimit => {
    const immStepOne = immModifyLimit.getIn(['steps', FIRST_STEP]);
    const tentativeLimit = immStepOne.get('tentativeLimit');
    const maximumLimitAutorize = immStepOne.get('maximumLimitAutorize');

    if (maximumLimitAutorize === 0 || tentativeLimit <= maximumLimitAutorize) {
       return false;
    }

    if (getSuggestedAmount(immModifyLimit) === 0) {
        return false;
    }

    if (maximumLimitAutorize <= immStepOne.get('currentLimit')) {
        return false;
    }

    return true;
};

const setUpStep = limit =>  {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_SETUP_STEP,
        payload: {
            currentLimit: limit.get('amount'),
            currency: limit.get('currency'),
            tentativeLimit: limit.get('amount')
        }
    };
};

const resetStep = limit =>  {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_RESET_STEP,
        payload: {
            limit
        }
    };
};

const setAgreementCheckbox = evt => ({
    type: actionTypes.CARD_MODIFY_LIMIT_SET_AGREEMENT_CHECKBOX,
    payload: {
        checked: evt.target.checked
    }
})

const getLimits = () => ({type: actionTypes.CARD_GET_LIMITS});

const setLimit = newLimit => (dispatch, getState) => {
    const immStepOne = getState().cardModifyLimit.getIn(['steps', FIRST_STEP]);
    const currentLimit = immStepOne.get('currentLimit');
    let operationType = CARD_MODIFY_LIMIT_DECREASE;

    if (currentLimit < newLimit) {
        const maximumAutorizedLimit = immStepOne.get('maximumLimitAutorize');
        if (maximumAutorizedLimit < newLimit) {
            operationType = CARD_MODIFY_LIMIT_INCREASE_PENDING;
        } else {
            operationType = CARD_MODIFY_LIMIT_INCREASE_APPROVED;
        }
    }

    dispatch({
        type: actionTypes.CARD_MODIFY_LIMIT_SET_LIMIT,
        payload: {
            limit: newLimit,
            operationType
        }
    });
}

function setVisibleStep(step) {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

const validateStep = step => (dispatch, getState) => {
    if (step === 1) {
        const immModifyLimit = getState().cardModifyLimit;
        const showModal = shouldShowModal(immModifyLimit);
        const suggestedAmount = getSuggestedAmount(immModifyLimit);

        if (showModal) {
            dispatch({
                type: actionTypes.CARD_MODIFY_LIMIT_SHOW_MODAL,
                payload: {
                    suggestedAmount
                }
            });
        }
    }

    const isRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    
    dispatch({
        type: actionTypes.CARD_MODIFY_LIMIT_VALIDATE_STEP,
        payload: {
            step,
            isRevolving
        }
    });
};

function setWillCancel(willCancel) {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function clearRequest() {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_CLEAR
    };
}

const handleCloseModal = () => ({type: actionTypes.CARD_MODIFY_LIMIT_CLOSE_MODAL});

const handleModalContinueButtonClick = modalSelectedOption => (dispatch, getState) => {
    if (modalSelectedOption === CARD_MODIFY_LIMIT_INCREASE_APPROVED) {
        const suggestedAmount = getState().cardModifyLimit.getIn(['steps', FIRST_STEP, 'suggestedAmount']);
        const currency = getState().cardModifyLimit.get('currency');
        dispatch(setLimit(suggestedAmount, currency));
    }
    dispatch(handleCloseModal());
    dispatch(setVisibleStep(2));
};

const cardIncreaseLimitsRequest = () => {
    return {
        type: actionTypes.CARD_INCREASE_LIMITS_REQUEST
    };
};

const cardIncreaseLimitsSuccess = response => {
    return {
        type: actionTypes.CARD_INCREASE_LIMITS_SUCCESS,
        payload: {
            creditLimitList: get(response, ['tarjetaList', 'tarjetaList', 0, 'limitesCreditoList', 'limitesCreditoList'], []) || [],
            cardReferenceData: get(response, ['tarjetaList', 'tarjetaList', 0, 'tarjetaRef'], {}) || {},
            maximumLimitAutorize: Math.min(response.limiteMaximoAutorizar || 0, CARD_MODIFY_LIMIT_MAX_TO_AUTHORIZE)
        }
    };
};

const cardRequestLimitsFailure = error => {
    return {
        type: actionTypes.CARD_REQUEST_LIMITS_FAILURE,
        payload: {
            error
        }
    };
};


const getIncreaseLimits = immCard => dispatch => {
    const type = immCard.get('newProduct');
    const subType = immCard.get('productSubType');
    const standard = immCard.getIn(['criteria', 'c1', 'estand']);

    const params = {
        query: {
            tipo: type,
            subtipo: subType,
            standard
        }
    };

    return APIGet({ dispatch, endpoint: 'hireCards', params })
    .then(response => {
        dispatch(cardIncreaseLimitsSuccess(response));
        dispatch(getLimits());
    })
    .catch(response => {
        if(!!response.error) {
            dispatch(cardRequestLimitsFailure(response.error));
        } else {
            throw response;
        }
    });
};

const modifyLimit = cardId => (dispatch, getState) => {
    const operationType = getState().cardModifyLimit.get('operationType');
    if (operationType === CARD_MODIFY_LIMIT_DECREASE) {
        dispatch(requestDecreaseLimit(cardId));
    } else {
        dispatch(requestIncreaseLimit(cardId));
    }
};

const requestLimits = cardId => (dispatch, getState) => {
    const immCard =  getState().cards.getIn(['byId', cardId]);
    dispatch(cardIncreaseLimitsRequest());
    dispatch(getIncreaseLimits(immCard));
};

module.exports = {
    setAgreementCheckbox,
    setLimit,
    resetStep,
    setUpStep,
    setVisibleStep,
    validateStep,
    setWillCancel,
    modifyLimit,
    clearRequest,
    requestLimits,
    handleCloseModal,
    handleModalContinueButtonClick
};
